
<div class="cuerpo">

    <h2>{{nombre | titlecase}}</h2>
    <h3>{{usuario}}</h3>
    <app-clasebox *ngFor="let clase of clases" [datos]="clase" [userUid]="userUid">
    </app-clasebox>
</div>